import "./subwidget.css";

import ActiveSubTimWe from "./ActiveSubTimWE";
import CountSubUnSubDailyTimWe from "./CountSubUnSubDailyTimeWe";
import SubHistoryTimWeBH from "./SubHistoryTimWeBH";
import SubPostedTimWe from "./SubPostedTimWe";
import CountSubUnSubDailyVibe from "./CountSubUnSubDailyVibe";
import NotificationByCompany from "./notificationByCompany";
import PinApiPostedVibe from "./PinApiPostedVibe";

const SubWidgetVibeSA = ({ table, role }) => {
    const colors = ["red", "green", "blue", "brown"];
    const randomIndex = Math.floor(Math.random() * colors.length);
    const randomColor = colors[randomIndex];


    return (
        <div
            className="col-10 "
            style={{
                position: "relative",
                left: "250px",
                top: "100px",
            }}
        >
            <div className="row  p-3">
                {role !== "accountant" && (
                    <>
                        <div className="row justify-content-center">
                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Daily Report SA{" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : table === "katcha" ? (
                                            <>Katcha</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <CountSubUnSubDailyVibe table={table + "/countSubUnSubSA"} />
                                </div>
                            </div>

                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    ActiveSub SA {" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : table === "katcha" ? (
                                            <>Katcha</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <ActiveSubTimWe table={table + "/SA"} />
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-9 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Billing {" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : table === "katcha" ? (
                                            <>Katcha</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <NotificationByCompany table={table} />
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    PIN API SA {" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : table === "katcha" ? (
                                            <>Katcha</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <PinApiPostedVibe table={table + "/getPinAPIPosted"} />
                                </div>
                            </div>

                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    Billable Posted SA {" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : table === "katcha" ? (
                                            <>Katcha</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <PinApiPostedVibe table={table + "/getS2SPostedBillable"} />
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-5 shadow ml-5">
                                <h2 className="text-secondary font-weight-bold">
                                    NonBillable Posted SA {" "}
                                    <span style={{ color: randomColor }}>
                                        {table === "vibelytics" ? (
                                            <>Vibelytics SA</>
                                        ) : table === "stylistsa" ? (
                                            <>AI-Stylist SA</>
                                        ) : table === "eyetest" ? (
                                            <>EyeTest</>
                                        ) : table === "katcha" ? (
                                            <>Katcha</>
                                        ) : (
                                            <>Vibelytics</>
                                        )}
                                    </span>
                                </h2>
                                <div>
                                    <PinApiPostedVibe table={table + "/getS2SPostedNonBillable"} />
                                </div>
                            </div>

                        </div>
                    </>
                )}

            </div>
        </div >
    );
};

export default SubWidgetVibeSA;
